import React, { memo } from 'react'
import { Trans } from 'react-i18next'

import Text from '../shared/text/Text'
import { formatDecimalMinutes } from '../../util/app.helpers'
import useSaleTimer from '../../hooks/useSaleTimer'

const MultiplierTimer = ({ saleEnded }) => {
  const { key, value, diffMins } = useSaleTimer(saleEnded)
  return (
    !saleEnded &&
    value !== 1 && (
      <Text
        variant='body1'
        label={
          <Trans
            i18nKey='home.multiplier-active-for'
            values={{ value: key, points: value }}
          >
            <Text
              variant='body1'
              fontWeight={900}
              component='span'
              color='text.pink'
              label={formatDecimalMinutes(diffMins)}
            />
          </Trans>
        }
        fontWeight={900}
        textAlign='center'
      />
    )
  )
}

export default memo(MultiplierTimer)
